<template>
  <div
    :class="[
      'grid__item',
      'span--lg-' + spanDesktop,
      'span--md-' + spanTablet,
      'span--sm-' + spanMobile,
      // 'span-y--lg-' + spanYDesktop,
      // 'span-y--md-' + spanYTablet,
      // 'span-y--sm-' + spanYMobile,
      alignX ? 'align--x-' + alignX : '',
      alignY ? 'align--y-' + alignY : '',
    ]"
    data-comp="l-grid-item"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  spanDesktop: {
    type: [Number, String],
    default: 4,
  },
  spanTablet: {
    type: [Number, String],
    default: 6,
  },
  spanMobile: {
    type: [Number, String],
    default: 12,
  },
  // spanYDesktop: {
  //   type: [Number, String],
  //   default: 12,
  // },
  // spanYTablet: {
  //   type: [Number, String],
  //   default: 12,
  // },
  // spanYMobile: {
  //   type: [Number, String],
  //   default: 12,
  // },
  alignX: {
    type: String,
    default: "start",
    validator: (value) => {
      return ["start", "center", "end"].includes(value);
    },
  },
  alignY: {
    type: String,
    default: "start",
    validator: (value) => {
      return ["start", "center", "end"].includes(value);
    },
  },
});
</script>

<style lang="scss">
.grid__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--grid-item-gap-y);
}

.span {
  @for $i from 1 through 12 {
    &--sm-#{$i} {
      grid-column: span #{$i};
    }
  }

  @include global.breakpoint(mobile-landscape, max) {
    &--sm-0 {
      display: none;
    }
  }

  @include global.breakpoint(mobile-landscape, min) {
    @for $i from 1 through 12 {
      &--md-#{$i} {
        grid-column: span #{$i};
      }
    }

    &--md-0 {
      display: none;
    }
  }

  @include global.breakpoint(tablet-landscape, min) {
    @for $i from 1 through 12 {
      &--lg-#{$i} {
        grid-column: span #{$i};
      }
    }

    &--md-0 {
      display: flex;
    }

    &--lg-0 {
      display: none;
    }
  }
}

// .span-y {
//   @for $i from 1 through 12 {
//     &--sm-#{$i} {
//       grid-column: span #{$i};
//     }
//   }

//   @include global.breakpoint(mobile-landscape, max) {
//     &--sm-0 {
//       display: none;
//     }
//   }

//   @include global.breakpoint(mobile-landscape, min) {
//     @for $i from 1 through 12 {
//       &--md-#{$i} {
//         grid-column: span #{$i};
//       }
//     }

//     &--md-0 {
//       display: none;
//     }
//   }

//   @include global.breakpoint(tablet-landscape, min) {
//     @for $i from 1 through 12 {
//       &--lg-#{$i} {
//         grid-column: span #{$i};
//       }
//     }

//     &--md-0 {
//       display: flex;
//     }

//     &--lg-0 {
//       display: none;
//     }
//   }
// }

.align {
  &--y-start {
    justify-content: flex-start;
  }

  &--y-center {
    justify-content: center;
  }

  &--y-end {
    justify-content: flex-end;
  }

  &--x-start {
    align-items: flex-start;
  }

  &--x-center {
    align-items: center;
  }

  &--x-end {
    align-items: flex-end;
  }
}
</style>
